import { DOORSTEP_DELIVERY_SERVICES, ENVIRONMENTAL_RETURN_SERVICE_GERMANY_TYPE_ID, ENVIRONMENTAL_RETURN_SERVICE_TYPE_ID, FLIP_DOOR_DIRECTION_SERVICE_TYPE_ID, PLACE_AND_CONNECT_PRODUCT_AS_A_SERVICE, PLACE_AND_CONNECT_PRODUCT_AS_A_SERVICE_PRODUCT_ID, PLACE_AND_CONNECT_SERVICES, TELEVISIONS_PRODUCT_TYPE_ID, } from './constants.js';
export const getAllSelectedInstallationServices = (form) => {
    const mainServices = form.getAll('mainServices').map(String);
    const subServices = form.getAll('subServices').map(String);
    const individualMainServices = form.getAll('individualMainServices').map(String);
    return [...mainServices, ...subServices, ...individualMainServices];
};
export const getInstallationServiceAccessory = (form) => {
    return form.get('installationServiceAccessory');
};
export const filterServiceData = (serviceData, isSubscriptionProduct, isShoppingCart = false) => {
    const { services, disabledServices } = serviceData.reduce((previousValue, service) => {
        if (service.isHidden) {
            return previousValue;
        }
        if (!service.enabled) {
            previousValue.disabledServices.push(service);
        }
        else {
            previousValue.services.push(service);
        }
        return previousValue;
    }, {
        services: [],
        disabledServices: [],
    });
    const subServiceIds = services
        .map(service => service.subServices.map(subService => subService.serviceId))
        .flat();
    const filteredServices = services.filter(service => {
        return !subServiceIds.includes(service.serviceId) && !service.isStoreSpecific;
    });
    const filteredMainServices = filteredServices.filter(service => {
        return (!isIndividualMainService(service.installServiceTypeId, filteredServices.length === 1) &&
            !isEnvironmentalReturnService(service.installServiceTypeId));
    });
    if (isSubscriptionProduct) {
        return {
            filteredServices: removeDoorstepDeliveryServices(replacePlaceAndConnectServicesForSubscriptionProducts(filteredMainServices.filter(service => !service.showOnlyInShoppingCart))),
            individualMainServices: filteredServices.filter(service => isIndividualMainService(service.installServiceTypeId, filteredServices.length === 1)),
            disabledServices: disabledServices || [],
            environmentalReturnServices: filteredServices.filter(service => isEnvironmentalReturnService(service.installServiceTypeId)),
        };
    }
    return {
        filteredServices: isShoppingCart
            ? filteredMainServices
            : filteredMainServices.filter(service => !service.showOnlyInShoppingCart),
        individualMainServices: filteredServices.filter(service => isIndividualMainService(service.installServiceTypeId, filteredServices.length === 1)),
        disabledServices: disabledServices || [],
        environmentalReturnServices: filteredServices.filter(service => isEnvironmentalReturnService(service.installServiceTypeId)),
    };
};
export const replacePlaceAndConnectServicesForSubscriptionProducts = (services) => {
    return services.map(service => {
        if (PLACE_AND_CONNECT_SERVICES.includes(service.serviceId)) {
            return {
                ...service,
                serviceId: PLACE_AND_CONNECT_PRODUCT_AS_A_SERVICE,
                productId: PLACE_AND_CONNECT_PRODUCT_AS_A_SERVICE_PRODUCT_ID,
                salesPrice: {
                    ...service.salesPrice,
                    includingVat: 0,
                    excludingVat: 0,
                },
                isPreselected: true,
            };
        }
        return service;
    });
};
export const removeDoorstepDeliveryServices = (services) => {
    return services.filter(service => !DOORSTEP_DELIVERY_SERVICES.includes(service.serviceId));
};
export const isIndividualMainService = (serviceTypeId, onlyOneMainService) => serviceTypeId === FLIP_DOOR_DIRECTION_SERVICE_TYPE_ID || onlyOneMainService;
export const isEnvironmentalReturnService = (serviceTypeId) => serviceTypeId === ENVIRONMENTAL_RETURN_SERVICE_TYPE_ID ||
    serviceTypeId === ENVIRONMENTAL_RETURN_SERVICE_GERMANY_TYPE_ID;
export const isTelevision = (productTypeId) => Number(productTypeId) === TELEVISIONS_PRODUCT_TYPE_ID;
//# sourceMappingURL=InstallationServicesHelper.js.map